import { createAction } from '@'
import { SetFormValues } from '@form'
import { SetModalVisible } from '@modal'

export default createAction('OpenRegionHotelsModal', async (params = {}) => {
    SetFormValues('RegionCoverageHotelsForm', {
        mode: params.mode || 'create',
        region_id: params.region_id || '',
        supplier_code: params.supplier_code || 'EPS',
        hotel_ids: '',
        copy_from_region_id: '',
        lock_region: !!params.region_id
    })
    SetModalVisible('RegionCoverageHotelsForm', true)
})
